export { default } from "./details-section";
